import { ThemeConfig } from 'antd';

import { ThemeVariables } from '@/interfaces/theme';

import components from './components';
import tokens from './tokens';
import variables from './variables';
import defaultTokens from '../default/tokens';

const lightTheme = {
  variables,
  components,
  token: { ...defaultTokens, ...tokens }
} as ThemeConfig & { variables: ThemeVariables };

export default lightTheme;
